@if (!!errorMsg) {
  <div (window:resize)="onResize()">
    <app-message [active]="!!errorMsg" [message]="errorMsg"/>
  </div>
}

<div *ngIf="!errorMsg && matchIntern && dataLoaded && matchData" (window:resize)="onResize()">
  <div class="matchContainer" [class.matchContainer-full]="matchData.countPlayersPerParticipant > 1">
    @if (matchData.legs?.length > 1) {
      <div class="flex row-legs justify-content-between pb-2 table-design">
        <table>
          @if (matchData.sets?.length > 1) {
            <tr>
              <th></th>
              <th *ngFor="let set of matchData.sets" [colSpan]="set.legsCount" class="text-center">
                Set {{(set.index + 1)}}
              </th>
            </tr>
          }
          <tr>
            <th>Leg</th>
            <th *ngFor="let leg of matchData.legs" [class.selected]="currentLegIndex === leg?.totalLegIndex">
              <p-button [label]="(leg?.legIndex + 1) + ''"
                        styleClass="p-button-rounded p-button-text text-white"
                        [pTooltip]="'SHOWS_LEG' | translate"
                        [showDelay]="400"
                        (click)="currentLegIndex = leg?.totalLegIndex"/>
              <!-- [style]="isMobile ? '' : 'margin-left: -16px; margin-right: -16px;'" -->
            </th>
          </tr>
          <tr *ngFor="let player of matchData.players; let playerIndex = index"
              [class.border-separator]="player.playerIndex > 0 && player.playerPosition === 0">
            <td class="py-1">{{player.name}}</td>
            <!-- [class.accent]="currentLegIndex === leg.totalLegIndex" -->
            <!-- [class.underline]="leg.winnerPlayerIndex === playerIndex && leg.startingPlayerIndex !== leg.winnerPlayerIndex" -->
            <td *ngFor="let leg of matchData.legs"
                class="text-center"
                [class.underline]="leg.isBreak[playerIndex]"
                [class.text-gray-500]="!(leg.winnerPlayerIndex === playerIndex)"
                [pTooltip]="(leg.winnerPlayerIndex === playerIndex ? (leg.isBreak[playerIndex] ? 'Break' : '') : 'REMAINING_POINTS') | translate" showDelay="400">
              {{leg.winnerPlayerIndex === playerIndex ? (leg.winnerDarts + '') : ('(' + leg.scoreLeft[playerIndex] + ')')}}
            </td>
          </tr>
        </table>
      </div>
    }

    @if (multiplePlayersView) {
      <div *ngIf="currentLegIndex >= 0" class="flex row-maincontent align-items-stretch">
        <div class="flex-grow-1 justify-content-center div-scoreboard">
          <table class="scoreboard" width="100%" height="100%">
            <tr>
              @for (player of matchData.players; track i; let i = $index) {
                @if (i === 0) {
                  <th></th>
                }
                <th colspan="2">
                  <div [fittext]="true" [maxFontSize]="maxFontSizePlayer" [delay]="0" class="text-center"
                       [class.startPlayer]="matchData.legs[currentLegIndex]?.startingPlayerIndex === i">
                    {{player?.name}}
                  </div>
                </th>
              }
            </tr>
            <tr>
              @for (player of matchData.players; track i; let i = $index) {
                @if (i === 0) {
                  <th></th>
                }
                <th class="scoreboard-header text-center">{{'POINTS' | translate}}</th>
                <th class="scoreboard-header text-center">{{'SCORE' | translate}}</th>
              }
            </tr>
            <tr>
              @for (player of matchData.players; track i; let i = $index) {
                @if (i === 0) {
                  <th class="scoreboard-throws"></th>
                }
                <td class="score"></td>
                <td class="score">
                  {{matchData.x01}}
                </td>
              }
            </tr>
            <tr *ngFor="let wurf of matchData.legs[currentLegIndex]?.throws; let i = index" [attr.data-index]="i">
              @for (player of matchData.players; track j; let j = $index) {
                @if (j === 0) {
                  <td class="px-1 scoreboard-throws text-center">{{((i + 1) * 3)}}</td>
                }
                <td class="score" [class.finish-line]="wurf[j]?.strikeThroughPoints" [class.text-green]="wurf[j]?.checked">
                  <div>
                    {{wurf[j]?.points}}
                  </div>
                  @if (showSingleDarts) {
                    <div class="flex scoreboard-singledart">
                      <div class="flex-1">
                        @if (wurf[j]?.multiplicator1 >= 1) {
                          {{wurf[j]?.dart1 * wurf[j]?.multiplicator1}}
                        } @else {
                          -
                        }
                      </div>
                      <p-divider layout="vertical"/>
                      <div class="flex-1">
                        @if (wurf[j]?.multiplicator2 >= 1) {
                          {{wurf[j]?.dart2 * wurf[j]?.multiplicator2}}
                        } @else {
                          -
                        }
                      </div>
                      <p-divider layout="vertical"/>
                      <div class="flex-1">
                        @if (wurf[i]?.multiplicator3 >= 1) {
                          {{wurf[j]?.dart3 * wurf[j]?.multiplicator3}}
                        } @else {
                          -
                        }
                      </div>
                    </div>
                  }
                </td>
                <td class="score" [class.finish-line]="wurf[j]?.strikeThroughScore" [class.text-green]="wurf[j]?.checked">
                  {{wurf[j]?.score}}
                </td>
              }
            </tr>
          </table>
        </div>
      </div>

    } @else {

      <div class="grid grid-nogutter row-header align-content-center">
        <div class="col">
          <div class="playername text-center" [showDelay]="400"
               [class.startPlayer]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 0"
               [class.font-bold]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 0"
               [pTooltip]="(matchData.legs[currentLegIndex]?.startingPlayerIndex === 0 ? 'START_PLAYER' : '') | translate">
            <div [fittext]="true" [maxFontSize]="maxFontSizePlayer" [delay]="0">
              {{matchIntern.participantHome?.displayName}}
            </div>
          </div>
        </div>
        <div class="col">
          <div class="playername text-center"
               [class.startPlayer]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 1" [showDelay]="400"
               [class.font-bold]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 1"
               [pTooltip]="(matchData.legs[currentLegIndex]?.startingPlayerIndex === 1 ? 'START_PLAYER' : '') | translate">
            <div [fittext]="true" [maxFontSize]="maxFontSizePlayer" [delay]="0">
              {{matchIntern.participantGuest?.displayName}}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="currentLegIndex >= 0" class="flex row-maincontent align-items-stretch">
        <div class="flex-grow-1 justify-content-center div-scoreboard">
          <table class="scoreboard" width="100%" height="100%">
            <tr *ngIf="matchData.countPlayersPerParticipant > 1">
              <th colspan="2">
                <div [fittext]="true" [maxFontSize]="maxFontSizePlayer" [delay]="0" class="text-center"
                     [class.startPlayer]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 0 && matchData.legs[currentLegIndex]?.startingPlayerPosition === 0">
                  {{matchData.players[0]?.name}}
                </div>
              </th>
              <th colspan="2">
                <div [fittext]="true" [maxFontSize]="maxFontSizePlayer" [delay]="0" class="text-center"
                     [class.startPlayer]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 0 && matchData.legs[currentLegIndex]?.startingPlayerPosition === 1">
                  {{matchData.players[1]?.name}}
                </div>
              </th>
              <th>
              </th>
              <th colspan="2">
                <div [fittext]="true" [maxFontSize]="maxFontSizePlayer" [delay]="0" class="text-center"
                     [class.startPlayer]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 1 && matchData.legs[currentLegIndex]?.startingPlayerPosition === 0">
                  {{matchData.players[matchData.countPlayersPerParticipant]?.name}}
                </div>
              </th>
              <th colspan="2">
                <div [fittext]="true" [maxFontSize]="maxFontSizePlayer" [delay]="0" class="text-center"
                     [class.startPlayer]="matchData.legs[currentLegIndex]?.startingPlayerIndex === 1 && matchData.legs[currentLegIndex]?.startingPlayerPosition === 1">
                  {{matchData.players[matchData.countPlayersPerParticipant + 1]?.name}}
                </div>
              </th>
            </tr>
            <tr>
              <th class="scoreboard-header text-center">{{'POINTS' | translate}}</th>
              <th class="scoreboard-header text-center">{{'SCORE' | translate}}</th>
              <th *ngIf="matchData.countPlayersPerParticipant > 1" class="scoreboard-header text-center">{{'POINTS' | translate}}</th>
              <th *ngIf="matchData.countPlayersPerParticipant > 1" class="scoreboard-header text-center">{{'SCORE' | translate}}</th>
              <th class=""></th>
              <th class="scoreboard-header text-center">{{'POINTS' | translate}}</th>
              <th class="scoreboard-header text-center">{{'SCORE' | translate}}</th>
              <th *ngIf="matchData.countPlayersPerParticipant > 1" class="scoreboard-header text-center">{{'POINTS' | translate}}</th>
              <th *ngIf="matchData.countPlayersPerParticipant > 1" class="scoreboard-header text-center">{{'SCORE' | translate}}</th>
            </tr>
            <tr>
              <td class="score">
                @if (showStartPlayer) {
                  <div class="text-xs">
                    <div>{{'START_PLAYER' | translate}}:</div>
                    <div>{{getStartPlayerName(0)}}</div>
                  </div>
                }
              </td>
              <td class="score">
                {{matchData.x01}}
              </td>
              <td *ngIf="matchData.countPlayersPerParticipant > 1" class="score"></td>
              <td *ngIf="matchData.countPlayersPerParticipant > 1" class="score">
                {{matchData.x01}}
              </td>
              <td class=""></td>
              <td class="score">
                @if (showStartPlayer) {
                  <div class="text-xs">{{'START_PLAYER' | translate}}</div>
                  <div class="text-xs">{{getStartPlayerName(1)}}</div>
                }
              </td>
              <td class="score">
                {{matchData.x01}}
              </td>
              <td *ngIf="matchData.countPlayersPerParticipant > 1" class="score"></td>
              <td *ngIf="matchData.countPlayersPerParticipant > 1" class="score">
                {{matchData.x01}}
              </td>
            </tr>
            <tr *ngFor="let wurf of matchData.legs[currentLegIndex]?.throws; let i = index" [attr.data-index]="i">
              <td class="score" [class.finish-line]="wurf[0]?.strikeThroughPoints" [class.text-green]="wurf[0]?.checked">
                <div>
                  {{wurf[0]?.points}}
                </div>
                @if (showSingleDarts) {
                  <div class="flex scoreboard-singledart">
                    <div class="flex-1">
                      @if (wurf[0]?.multiplicator1 >= 1) {
                        {{wurf[0]?.dart1 * wurf[0]?.multiplicator1}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[0]?.multiplicator2 >= 1) {
                        {{wurf[0]?.dart2 * wurf[0]?.multiplicator2}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[0]?.multiplicator3 >= 1) {
                        {{wurf[0]?.dart3 * wurf[0]?.multiplicator3}}
                      } @else {
                        -
                      }
                    </div>
                  </div>
                }
              </td>
              <td class="score" [class.finish-line]="wurf[0]?.strikeThroughScore"  [class.text-green]="wurf[0]?.checked">
                {{wurf[0]?.score}}
              </td>
              <td *ngIf="matchData.countPlayersPerParticipant > 1" class="score"
                  [class.finish-line]="wurf[1]?.strikeThroughPoints">
                <div>
                  {{wurf[1]?.points}}
                </div>
                @if (showSingleDarts) {
                  <div class="flex scoreboard-singledart">
                    <div class="flex-1">
                      @if (wurf[1]?.multiplicator1 >= 1) {
                        {{wurf[1]?.dart1 * wurf[1]?.multiplicator1}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[1]?.multiplicator2 >= 1) {
                        {{wurf[1]?.dart2 * wurf[1]?.multiplicator2}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[1]?.multiplicator3 >= 1) {
                        {{wurf[1]?.dart3 * wurf[1]?.multiplicator3}}
                      } @else {
                        -
                      }
                    </div>
                  </div>
                }
              </td>
              <td *ngIf="matchData.countPlayersPerParticipant > 1" class="score"
                  [class.finish-line]="wurf[1]?.strikeThroughScore">
                {{wurf[1]?.score}}
              </td>

              <td class="pl-1 pr-1 scoreboard-throws text-center">{{((i + 1) * 3)}}</td>

              <td class="score" [class.finish-line]="wurf[1]?.strikeThroughPoints"  [class.text-green]="wurf[1]?.checked">
                <div>
                  {{wurf[matchData.countPlayersPerParticipant]?.points}}
                </div>
                @if (showSingleDarts) {
                  <div class="flex scoreboard-singledart">
                    <div class="flex-1">
                      @if (wurf[matchData.countPlayersPerParticipant]?.multiplicator1 >= 1) {
                        {{wurf[matchData.countPlayersPerParticipant]?.dart1 * wurf[matchData.countPlayersPerParticipant]?.multiplicator1}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[matchData.countPlayersPerParticipant]?.multiplicator2 >= 1) {
                        {{wurf[matchData.countPlayersPerParticipant]?.dart2 * wurf[matchData.countPlayersPerParticipant]?.multiplicator2}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[matchData.countPlayersPerParticipant]?.multiplicator3 >= 1) {
                        {{wurf[matchData.countPlayersPerParticipant]?.dart3 * wurf[matchData.countPlayersPerParticipant]?.multiplicator3}}
                      } @else {
                        -
                      }
                    </div>
                  </div>
                }
              </td>
              <td class="score" [class.finish-line]="wurf[1]?.strikeThroughScore"  [class.text-green]="wurf[1]?.checked">
                {{wurf[matchData.countPlayersPerParticipant]?.score}}
              </td>
              <td *ngIf="matchData.countPlayersPerParticipant > 1" class="score"
                  [class.finish-line]="wurf[matchData.countPlayersPerParticipant + 1]?.strikeThroughPoints"
                  [class.text-green]="wurf[matchData.countPlayersPerParticipant + 1]?.checked">
                <div>
                  {{wurf[matchData.countPlayersPerParticipant + 1]?.points}}
                </div>
                @if (showSingleDarts) {
                  <div class="flex scoreboard-singledart">
                    <div class="flex-1">
                      @if (wurf[matchData.countPlayersPerParticipant + 1]?.multiplicator1 >= 1) {
                        {{wurf[matchData.countPlayersPerParticipant + 1]?.dart1 * wurf[matchData.countPlayersPerParticipant + 1]?.multiplicator1}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[matchData.countPlayersPerParticipant + 1]?.multiplicator2 >= 1) {
                        {{wurf[matchData.countPlayersPerParticipant + 1]?.dart2 * wurf[matchData.countPlayersPerParticipant + 1]?.multiplicator2}}
                      } @else {
                        -
                      }
                    </div>
                    <p-divider layout="vertical"/>
                    <div class="flex-1">
                      @if (wurf[matchData.countPlayersPerParticipant + 1]?.multiplicator3 >= 1) {
                        {{wurf[matchData.countPlayersPerParticipant + 1]?.dart3 * wurf[matchData.countPlayersPerParticipant + 1]?.multiplicator3}}
                      } @else {
                        -
                      }
                    </div>
                  </div>
                }
              </td>
              @if (matchData.countPlayersPerParticipant > 1) {
                <td class="score"
                    [class.finish-line]="wurf[matchData.countPlayersPerParticipant + 1]?.strikeThroughScore"
                    [class.text-green]="wurf[matchData.countPlayersPerParticipant + 1]?.checked">
                  {{wurf[matchData.countPlayersPerParticipant + 1]?.score}}
                </td>
              }
            </tr>
          </table>
        </div>
      </div>
    }
    <div class="flex row-footer justify-content-between mt-auto mb-auto align-items-center">
      <div class="absolute w-full text-right pr-2" *ngIf="matchIntern.matchmode">
        {{matchIntern.matchmode | setlegmodePipe: 'sets/legs': false}}
      </div>
    </div>
  </div>

  <div class="font-italic gray mt-3">
    *{{'STATISTIC_BREAK_HELP' | translate}}<br>
    &nbsp;&nbsp;{{'STATISTIC_DS_HELP' | translate}}
  </div>
  @if (hasSingleDarts) {
    <div class="pt-3">
      <app-switch label="SHOW_SINGLE_DARTS" [(value)]="showSingleDarts"/>
    </div>
  }
</div>
